<template>
    <section :id="component.identifier ? component.identifier : ''" v-if="show" ref="container" class="mb-64">

        <component-header :description="description" :title="title"></component-header>

        <component :is="'style'" v-html="customStyles"></component>

        <div
            v-if="style === 'full_width'"
            class="site__container"
        >
            <div
                v-for="(value, index) in component.values"
                :key="value.id"
                :class="[ index % 2 ? containerFlexRowReverse : containerFlexRow, containerMargin, containerPadding]"
                class="flex"
            >
                <div
                    :class="[ index % 2 ? textMLAuto : textMRAuto, textWidth]"
                    class="flex items-center"
                >
                    <div :class="[ index % 2 ? textPaddingLeft : textMarginRight]">
                        <h2 :class="textSize" class="mb-24 site__font--display font-semibold">{{ translated(value.title) }}</h2>
                        <p class="leading-loose" v-html="translated(value.description)"></p>
                    </div>
                </div>

                <div :class="[ imageMarginBottom, imageDisplay, imageWidth]" class="justify-center">
                    <div
                        v-if="value.image_url"
                        :class="[ index % 2 ? [imageMarginRight, imageFloatRight].join(' ') : [imagePaddingLeft, imageFloatLeft].join(' ')]"
                        class="flex-none w-screen value-picture flex items-center relative"
                    >
                        <div
                            :class="imageDisplayOption1"
                            class="w-full relative"
                            style="padding-top: 66.6666%"
                        >
                            <div class="absolute inset-0">
                                <div :class="[ index % 2 ? 'justify-start' : 'justify-end']" class="flex items-center h-full relative">
                                    <div
                                        v-if="getVideoUrl(value)"
                                        class="absolute inset-0"
                                        data-popup="video"
                                    >
                                        <div
                                            class="absolute inset-0 flex items-center justify-center cursor-pointer site__color--brand-contrast z-10 trigger"
                                        >
                                            <icon-play class="h-72"></icon-play>
                                            <div class="hidden">
                                                <div class="w-400 md:w-768">
                                                    <play-video :url="getVideoUrl(value)"></play-video>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <img
                                        :alt="translated(value.title)"
                                        :class="[ index % 2 ? 'site__rounded--medium-right' : 'site__rounded--medium-left' ]"
                                        :src="value.image_url + '&w=770&h=550&fit=crop'"
                                        class="max-h-full"
                                    >
                                </div>
                            </div>
                        </div>
                        <div :class="imageDisplayOption2" class="relative">
                            <div
                                v-if="getVideoUrl(value)"
                                class="absolute inset-0"
                                data-popup="video"
                            >
                                <div
                                    class="absolute inset-0 flex items-center justify-center cursor-pointer site__color--brand-contrast z-10 trigger"
                                >
                                    <icon-play class="h-72"></icon-play>
                                    <div class="hidden">
                                        <div class="w-400 md:w-768">
                                            <play-video :url="getVideoUrl(value)"></play-video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img
                                :alt="translated(value.title)"
                                :class="[ imageDisplayOption2 ]"
                                :src="value.image_url + '&w=770&h=550&fit=crop'"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="site__container flex flex-col">
            <div
                v-for="(value, index) in component.values"
                :key="value.id"
                :class="[ container2Margin, index % 2 ? containerFlexRowReverse : containerFlexRow]"
                class="flex items-stretch pt-32"
            >

                <div :class="[ image2Width ]" class="px-8 mb-48">
                    <div
                        :class="[ image2Padding, index % 2 ? 'pr-24' : 'pl-24' ]"
                        class="h-full flex flex-col justify-center">

                        <div :class="trickyPadding" class="flex-grow"></div>

                        <div v-if="value.image_url" class="relative">

                            <div :class="[ image2MarginBottom ]"
                                class="relative">
                                <div
                                    v-if="getVideoUrl(value)"
                                    data-popup="video"
                                >
                                    <div
                                        class="absolute inset-0 flex items-center justify-center cursor-pointer site__color--brand-contrast z-10 trigger"
                                    >
                                        <icon-play class="h-72"></icon-play>
                                        <div class="hidden">
                                            <div class="w-400 md:w-768">
                                                <play-video :url="getVideoUrl(value)"></play-video>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div :class="[ image2Width, index % 2 ? 'right-0 ' + imageShadowMargin : 'left-0 ' + imageShadowPadding ]"
                                     class="absolute h-1/2 bottom-0 site__bg--brand site__rounded--medium">
                                </div>

                                <img :src="value.image_url + '&w=770&fit=max'" alt="" class="block w-full text-primary-80 relative site__rounded--medium">
                            </div>
                        </div>
                    </div>
                </div>

                <div :class="[ image2Width ]" class="flex items-center px-8">
                    <div :class="[ image2Padding ]">
                        <h2 :class="textSize" class="mb-24 site__font--display">
                            {{ translated(value.title) }}
                        </h2>
                        <p class="leading-loose" v-html="translated(value.description)">
                        </p>
                        <div :class="[ trickyPadding ]" class="flex-grow">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ComponentHeader from './ComponentHeader.vue';
import IconPlay from './icons/Play.vue';
import PlayVideo from './PlayVideo.vue';
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding';
import { responsive, runningInBrowser } from '../../helpers';
import { videoPlayer } from '../../../app/mixins/videoPlayer';
import imagesloaded from 'imagesloaded';

export default {
    components: {
        'component-header': ComponentHeader,
        'icon-play': IconPlay,
        'play-video': PlayVideo,
    },
    mixins: [videoPlayer()],
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {
            videoUrl: null,
            withImages: true,
        }
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        ...mapState(useBrandingStore, ['preview']),
        style () {
            return this.component.style;
        },
        show () {
            return runningInBrowser() || this.hasContent;
        },
        hasContent () {
            return this.component.values && !!this.component.values.length;
        },
        title: {
            get () {
                return this.translated(this.component.title);
            }
        },
        description: {
            get () {
                return this.translated(this.component.description);
            }
        },
        // w-5/12 - needed for purge css
        containerPadding () {
            return responsive(this.preview.type, 'pt-24 md:pt-48');
        },
        containerMargin () {
            return responsive(this.preview.type, 'mb-24 md:mb-48 lg:mb-64');
        },
        container2Margin () {
            return responsive(this.preview.type, 'mb-24 md:mb-48');
        },
        containerFlexRowReverse () {
            return responsive(this.preview.type, 'flex-col-reverse md:flex-row-reverse');
        },
        containerFlexRow () {
            return responsive(this.preview.type, 'flex-col-reverse md:flex-row');
        },
        textWidth () {
            return responsive(this.preview.type, 'w-full md:w-1/2 lg:w-5/12');
        },
        textMLAuto () {
            return responsive(this.preview.type, 'md:ml-auto');
        },
        textMRAuto () {
            return responsive(this.preview.type, 'md:mr-auto');
        },
        textPaddingLeft () {
            return responsive(this.preview.type, 'md:pl-24 lg:pl-0');
        },
        textMarginRight () {
            return responsive(this.preview.type, 'md:mr-24 lg:mr-0');
        },
        textSize () {
            return responsive(this.preview.type, 'text-heading-1 lg:text-heading-1');
        },
        imageMarginBottom () {
            return responsive(this.preview.type, 'mb-24 md:mb-0');
        },
        image2MarginBottom () {
            return responsive(this.preview.type, 'pb-24 lg:pb-48 mb-24 lg:mb-48');
        },
        imageDisplay () {
            return responsive(this.preview.type, 'flex md:block');
        },
        imageWidth () {
            return responsive(this.preview.type, 'w-full md:w-1/2 lg:w-5/12');
        },
        image2Width () {
            return responsive(this.preview.type, 'w-full md:w-1/2');
        },
        imageMarginRight () {
            return responsive(this.preview.type, 'md:mr-24 lg:mr-0');
        },
        // float-right - needed for purge css
        imageFloatRight () {
            return responsive(this.preview.type, 'md:float-right');
        },
        imagePaddingLeft () {
            return responsive(this.preview.type, 'md:pl-24 lg:pl-0');
        },
        image2Padding () {
            return responsive(this.preview.type, 'px-24 lg:px-48');
        },
        // float-left - needed for purge css
        imageFloatLeft () {
            return responsive(this.preview.type, 'md:float-left');
        },
        imageDisplayOption1 () {
            return responsive(this.preview.type, 'hidden md:block');
        },
        imageDisplayOption2 () {
            return responsive(this.preview.type, 'block md:hidden');
        },
        imageBackgroundRight () {
            return responsive(this.preview.type, 'md:bg-right');
        },
        imageBackgroundLeft () {
            return responsive(this.preview.type, 'md:bg-left');
        },
        siteContainerNegativeMargin () {
            return responsive(this.preview.type, 'lg:-mx-8');
        },
        trickyPadding () {
            return responsive(this.preview.type, 'max-h-24 lg:max-h-48');
        },
        imageShadowMargin () {
            return responsive(this.preview.type, '-mr-24 lg:-mr-48');
        },
        imageShadowPadding () {
            return responsive(this.preview.type, '-ml-24 lg:-ml-48');
        },
        customStyles () {

            if (!runningInBrowser()) {
                return `@media (min-width: 768px) {
                    .value-picture {
                        width: calc(100% + ((100vw - 200%) / 2));
                    }
                }
                @media (min-width: 1024px) {
                    .value-picture {
                        width: calc(100% + ((100vw - 240%) / 2));
                    }
                }`;
            }

            return {
                phone: `.value-picture {
                    width: calc(100% + 4.8rem);
                }`,
                tablet: `.value-picture {
                    width: calc(100% + 2.4rem);
                }`,
                desktop: `.value-picture {
                    width: calc(100% + (((1224px - 20rem) - 240%) / 2));
                }
                @media (min-width: 1224px) {
                    .value-picture {
                        width: calc(100% + (((100vw - 20rem) - 240%) / 2));
                    }
                }
                @media (min-width: 1380px) {
                    .value-picture {
                        width: calc(100% + ((((max(100vw, 1440px) - 20rem) * 0.83333) - 240%) / 2));
                    }
                }`,
            }[this.preview.type]
        }
    },
    methods: {
        getVideoUrl (value) {
            if (value.translated_video_url.hasOwnProperty(this.locale) &&
                this.validateVideo(value.translated_video_url[this.locale]))  {
                return this.embedVideo(value.translated_video_url[this.locale]);
            } else if (this.validateVideo(value.video_url)) {
                return this.embedVideo(value.video_url);
            }

            return null;
        },
    },
    mounted () {
        imagesloaded(this.$refs.container, instance => {
            this.$emit('loaded');
        });
    }
}
</script>
